import { injectReducer } from 'store/reducers'

export default (store) => ({
  path: 'practiceTemplateList',
  /*  Async getComponent is only invoked when route matches   */
  getComponent(nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([
      './containers/PracticeTemplateListContainer',
      './modules/practiceTemplateList'
    ], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const PracticeTemplateList = require('./containers/PracticeTemplateListContainer').default
      const actions = require('./modules/practiceTemplateList')
      const reducer = require('./modules/practiceTemplateList').default

      /*  Add the reducer to the store on key named below*/
      injectReducer(store, { key: 'practiceTemplateList', reducer: reducer })

      store.dispatch(actions.fetchPracticeTemplateLists())
      /*  Return getComponent   */
      cb(null, PracticeTemplateList)

      /* Webpack named bundle   */
    }, 'practiceTemplateList')
  }
})



// WEBPACK FOOTER //
// ./src/routes/PracticeTemplateList/index.js